import React from "react";
import { getRiskColor, getRiskBackground } from "../utils/riskUtils";

const DetectionResults = ({ detections, summary, isDetecting }) => {
  return (
    <div
      style={{
        display: "grid",
        // gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        marginTop: "10px",
      }}
    >
      {/* Recent Detections */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "25px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef",
        }}
      >
        <h3
          style={{
            color: "#2c3e50",
            marginBottom: "20px",
            fontSize: "1.3rem",
            fontWeight: "500",
          }}
        >
          🔍 Recent Detections
        </h3>

        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {!detections || detections.length === 0 ? (
            <div
              style={{ textAlign: "center", padding: "40px", color: "#999" }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🔎</div>
              <p>No detections yet</p>
              <small>Start detection to begin analysis</small>
            </div>
          ) : (
            detections.map((detection, index) => (
              <div
                key={index}
                style={{
                  background: getRiskBackground(detection.risk_level),
                  border: "1px solid #e9ecef",
                  borderLeft: `4px solid ${getRiskColor(detection.risk_level)}`,
                  padding: "15px",
                  marginBottom: "10px",
                  borderRadius: "4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ fontWeight: "600", color: "#2c3e50" }}>
                    {detection.class_name}
                  </span>
                  <span style={{ color: "#666", fontSize: "0.9rem" }}>
                    {(detection.confidence * 100).toFixed(1)}%
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "0.85rem",
                    color: "#999",
                  }}
                >
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: "12px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      background: getRiskColor(detection.risk_level),
                      color: "white",
                    }}
                  >
                    {detection.risk_level}
                  </span>
                  <span>
                    {new Date(detection.timestamp).toLocaleTimeString()} • Frame{" "}
                    {detection.frame_number}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Statistics */}
      {/* <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "25px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef",
        }}
      >
        <h3
          style={{
            color: "#2c3e50",
            marginBottom: "20px",
            fontSize: "1.3rem",
            fontWeight: "500",
          }}
        >
          📊 Statistics
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            gap: "15px",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "6px",
              textAlign: "center",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                fontSize: "1.8rem",
                fontWeight: "700",
                color: "#2c3e50",
                marginBottom: "5px",
              }}
            >
              {summary?.total_detections || 0}
            </div>
            <div style={{ color: "#666", fontSize: "0.9rem" }}>Total</div>
          </div>

          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "6px",
              textAlign: "center",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                fontSize: "1.8rem",
                fontWeight: "700",
                color: "#dc3545",
                marginBottom: "5px",
              }}
            >
              {summary?.high_risk_count || 0}
            </div>
            <div style={{ color: "#666", fontSize: "0.9rem" }}>High Risk</div>
          </div>

          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "6px",
              textAlign: "center",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                fontSize: "1.8rem",
                fontWeight: "700",
                color: "#4a90e2",
                marginBottom: "5px",
              }}
            >
              {summary?.session_info?.total_frames || 0}
            </div>
            <div style={{ color: "#666", fontSize: "0.9rem" }}>Frames</div>
          </div>
        </div>

        <div>
          <h4 style={{ marginBottom: "15px", color: "#2c3e50" }}>
            Risk Distribution
          </h4>
          {!summary || summary.total_detections === 0 ? (
            <div
              style={{ textAlign: "center", padding: "30px", color: "#999" }}
            >
              <div style={{ fontSize: "2rem", marginBottom: "10px" }}>📈</div>
              <small>Statistics will appear when detection starts</small>
            </div>
          ) : (
            Object.entries(summary.risk_distribution || {}).map(
              ([risk, count]) => {
                const percentage =
                  summary.total_detections > 0
                    ? ((count / summary.total_detections) * 100).toFixed(1)
                    : 0;

                return (
                  <div
                    key={risk}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      margin: "8px 0",
                      background: "white",
                      borderRadius: "4px",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          background: getRiskColor(risk),
                          borderRadius: "2px",
                        }}
                      ></div>
                      <span style={{ fontWeight: "500" }}>{risk}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "600" }}>{count}</span>
                      <small style={{ color: "#666", marginLeft: "5px" }}>
                        ({percentage}%)
                      </small>
                    </div>
                  </div>
                );
              }
            )
          )}
        </div>
      </div> */}
    </div>
  );
};

export default DetectionResults;
